import clsx from "clsx";
import styles from "./faq.module.css";
import { useEffect, useState } from "react";
import HomeNavbar from "../../Components/HomeNavbar/HomeNavbar";
import Footer from "../../Components/Footer/Footer";
import FaqCard from "./FaqCard";
import SEOHead from "../../Components/SEOHead/SEOHead";
import { getSEOByPath } from "../../config/seoConfig";

const FAQ = () => {
  const seoData = getSEOByPath("/faq");

  useEffect(() => {
    window.scrollTo(0, 0); // This will scroll the page to the top
  }, []);

  const [selected, setSelected] = useState("emp");

  const handleSelected = (item: string) => {
    setSelected(item);
  };

  return (
    <div className={styles.container}>
      {seoData && (
        <SEOHead
          title={seoData.title}
          description={seoData.description}
          canonical={seoData.canonical}
        />
      )}
      <HomeNavbar isHome={true} />
      <div className={styles.faqContent}>
        <h1 className={styles.header}>
          FAQs <span className={styles.redText}>⁉️</span>
        </h1>
        <div className={styles.btns}>
          <div
            onClick={() => {
              handleSelected("emp");
            }}
            className={clsx(
              selected === "emp" ? styles.gradientBtn : styles.whiteBtn
            )}
          >
            For Employers
          </div>
          <div
            onClick={() => {
              handleSelected("job");
            }}
            className={clsx(
              selected === "job" ? styles.gradientBtn : styles.whiteBtn
            )}
          >
            For Jobseekers
          </div>
        </div>
        {selected === "emp" ? (
          <div className={styles.faqCards}>
            <FaqCard
              question="How do I post a job on Forsatak?"
              answer="Posting a job is easy! Simply create an account, add your job details including description, skills required, and desired qualifications. Then, use your credits to activate the job posting."
            />
            <FaqCard
              question="Can I manage my job postings and applications?"
              answer="Absolutely! Your Forsatak dashboard allows you to view and edit active job postings, track applications, and communicate directly with interested candidates."
            />
            <FaqCard
              question="How do Forsatak credits work?"
              answer="Forsatak uses a credit system for job postings. One credit equals one job posting."
            />
            <FaqCard
              question="How does Forsatak help me find suitable applicants?"
              answer="Our advanced search filters allow you to find qualified candidates based on skills, experience, and other criteria. We also prioritize confidentiality and privacy by providing a secure platform for job seekers and employers to connect."
            />
            <FaqCard
              question="Is there a limit to how many jobs I can post?"
              answer="There is no limit to the number of jobs you can post on our platform. Feel free to post as many job listings as you need to fill your vacancies and attract top talent."
            />
          </div>
        ) : (
          <div className={styles.faqCards}>
            <FaqCard
              question="What is Forsatak?"
              answer="Forsatak is the first and exclusive Saudi and Emirati community platform designed to connect Saudi and Emirati jobseekers with hiring companies, offering personalized opportunities and resources for career development."
            />
            <FaqCard
              question="How do I sign up on the app?"
              answer="Download the Forsatak app and tap `Sign Up`. Enter your details, upload your CV, and create your profile to begin exploring job opportunities."
            />
            <FaqCard
              question="Who can join Forsatak?"
              answer="Forsatak is exclusively for Saudi and Emirati job seekers looking to connect with potential employers across various industries."
            />
            <FaqCard
              question="How does Forsatak help in finding a job?"
              answer="Our platform matches your skills and experience with job openings from reputable companies, providing tailored job recommendations and notifications about relevant opportunities."
            />
            <FaqCard
              question="Is there a fee for using Forsatak?"
              answer="Registration and usage of Forsatak are completely free for Saudi and Emirati job seekers."
            />
            <FaqCard
              question="How can I connect with hiring companies?"
              answer="Once registered, you can apply directly to job postings or attend exclusive networking events and webinars that connect you with potential employers."
            />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default FAQ;
